
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStore } from '@/plugins/store/index';
import GenericTable from '@/components/tables/GenericTable.vue';
import { HealthSegment, HealthSegmentStatistics } from '@/types';

export default defineComponent({
    components: { GenericTable },
    data() {
        function cellRendererSelector(params: any) {
            if (params.node.rowPinned) {
                return {
                    component: 'CustomPinnedRowCellRenderer',
                };
            }
            if (params.colDef.field === 'icon') {
                return {
                    component: 'IconCellRenderer',
                };
            }
            return {
                component: 'GenericCellRenderer',
            };
        }
        return {
            headers: [
                {
                    width: 8,
                    headerName: '',
                    field: 'icon',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Helbredssegment',
                    field: 'title',
                    sortable: true,
                    cellRendererSelector,
                },
                {
                    headerName: 'Antal',
                    field: 'amount',
                    sortable: true,
                    cellRendererSelector,
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['healthSegmentStatistics', 'healthSegments']),
        pinnedBottomRowData(): any {
            return [
                {
                    icon: null,
                    title: 'Total',
                    amount: this.items.reduce((accum, current) => {
                        return accum + current.amount;
                    }, 0),
                },
            ];
        },
        items(): any[] {
            if (!this.healthSegmentStatistics || !this.healthSegments) {
                return [];
            }
            return [
                ...this.healthSegments.map((segment: HealthSegment) => {
                    return {
                        title: segment.title,
                        amount: this.healthSegmentStatistics.filter((statistic: HealthSegmentStatistics) => statistic.ref === segment.id || statistic.refs?.includes(segment.id)).length,
                    };
                }),
            ];
        },
    },
});
